(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pv-offer-builder"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = (root) => {
      if (root.dataset.pvInitialized === 'true') return;
      root.dataset.pvInitialized = 'true';

      const rows = Array.from(root.querySelectorAll('[data-pv-variant]'));
      const availableRows = rows.filter((row) => row.dataset.available === 'true');
      const stepButtons = Array.from(root.querySelectorAll('[data-pv-step]'));
      const progress = root.querySelector('[data-pv-progress]');
      const countLabel = root.querySelector('[data-pv-count]');
      const summary = root.querySelector('[data-pv-summary]');
      const status = root.querySelector('[data-pv-status]');
      const dockProgress = root.querySelector('[data-pv-dock-progress]');
      const dockProgressFill = root.querySelector('[data-pv-dock-progress-fill]');
      const dockCount = root.querySelector('[data-pv-dock-count]');
      const dockTitle = root.querySelector('[data-pv-dock-title]');
      const dockBenefit = root.querySelector('[data-pv-dock-benefit]');
      const dockPrice = root.querySelector('[data-pv-dock-price]');
      const dockCta = root.querySelector('[data-pv-dock-cta]');
      const giftPicker = root.querySelector('[data-pv-gift-picker]');
      const giftSelect = root.querySelector('[data-pv-gift-select]');
      const goalFill = root.querySelector('[data-pv-goal-fill]');
      const goalMessage = root.querySelector('[data-pv-goal-message]');
      const pick = root.querySelector('[data-pv-pick]');
      const pickSummary = root.querySelector('[data-pv-pick-summary]');
      const pickList = root.querySelector('[data-pv-pick-list]');
      const configure = root.querySelector('[data-pv-configure]');
      const configureLabel = root.querySelector('[data-pv-configure-label]');
      const config = root.querySelector('[data-pv-config]');
      const nudge = root.querySelector('[data-pv-nudge]');
      const sheet = root.querySelector('[data-pv-sheet]');
      const sheetPanel = root.querySelector('[data-pv-sheet-panel]');
      const sheetMeta = root.querySelector('[data-pv-sheet-meta]');
      const sheetCta = root.querySelector('[data-pv-sheet-cta]');
      const productInfo = root.closest('product-info');
      const infoContainer = root.closest('.product__info-container');
      const maxPill = root.querySelector('[data-pv-tier-max]');
      const maxQty = Number(root.dataset.maxQty) || 4;
      // Eigenes Angebot ohne Kaching: kein Widget fernsteuern, der Builder legt immer selbst ein.
      const native = root.dataset.offer === 'native';
      const counts = rows.map(() => 0);
      let syncTimer;
      let appSyncAttempts = 0;
      let variantSyncAttempts = 0;
      // Menge über der größten Kaching-Stufe (oder eigenes Angebot): der Builder legt selbst in den Warenkorb.
      let extraMode = false;

      const total = () => counts.reduce((sum, count) => sum + count, 0);
      const selectedSequence = () => {
        const sequence = [];
        rows.forEach((row, index) => {
          for (let item = 0; item < counts[index]; item += 1) sequence.push(row.dataset.variantTitle);
        });
        return sequence;
      };

      const setSubmitReady = (ready) => {
        const submit = infoContainer && infoContainer.querySelector('[id^="ProductSubmitButton-"]');
        if (submit) submit.disabled = !ready;
        if (dockCta) dockCta.disabled = !ready;
        if (sheetCta) sheetCta.disabled = !ready;
        status.textContent = ready ? root.dataset.ready : root.dataset.syncing;
      };

      const getSettings = () => {
        const settingsScripts = Array.from(document.querySelectorAll('script.kaching-bundles-deal-block-settings'));
        for (const script of settingsScripts) {
          try {
            const parsed = JSON.parse(script.textContent || '{}');
            const ids = (parsed.selectedProductIds || []).map(String);
            if (ids.includes(root.dataset.productId)) return parsed;
          } catch (error) {
            continue;
          }
        }
        return null;
      };

      const getKachingGiftSelect = (bar) => {
        if (!bar || !giftSelect) return null;
        const giftValues = Array.from(giftSelect.options).map((option) => option.value);
        return Array.from(bar.querySelectorAll('select.kaching-bundles__bar-variant-select')).find((candidate) => {
          const candidateValues = Array.from(candidate.options).map((option) => option.value);
          return giftValues.length > 0 && giftValues.every((value) => candidateValues.includes(value));
        });
      };

      const applyKachingGift = (bar) => {
        if (!giftSelect) return true;
        const kachingGiftSelect = getKachingGiftSelect(bar);
        if (!kachingGiftSelect) return false;
        if (kachingGiftSelect.value !== giftSelect.value) {
          const valueSetter = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, 'value')?.set;
          if (valueSetter) valueSetter.call(kachingGiftSelect, giftSelect.value);
          else kachingGiftSelect.value = giftSelect.value;
          kachingGiftSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return kachingGiftSelect.value === giftSelect.value;
      };

      const verifyKachingSelection = (barId, sequence) => {
        if (!infoContainer) return false;
        const bar = infoContainer.querySelector(`[data-deal-bar-id="${barId}"]`);
        if (!bar || !bar.classList.contains('kaching-bundles__bar--selected')) return false;
        const slots = Array.from(bar.querySelectorAll('.kaching-bundles__bar-variant'));
        if (slots.length < sequence.length) return false;
        const variantsReady = sequence.every((title, index) => {
          const selected = slots[index].querySelector('.kaching-bundles__swatch-buttons__button--selected');
          return selected && selected.dataset.value === title;
        });
        if (!variantsReady) return false;
        if (sequence.length < 3 || !giftSelect) return true;
        const kachingGiftSelect = getKachingGiftSelect(bar);
        return Boolean(kachingGiftSelect && kachingGiftSelect.value === giftSelect.value);
      };

      const applyKachingVariants = (barId, sequence) => {
        if (!infoContainer) return;
        const bar = infoContainer.querySelector(`[data-deal-bar-id="${barId}"]`);
        if (!bar) return;
        const slots = Array.from(bar.querySelectorAll('.kaching-bundles__bar-variant'));
        if (slots.length < sequence.length) return;

        slots.forEach((slot, index) => {
          const target = Array.from(slot.querySelectorAll('.kaching-bundles__swatch-buttons__button')).find(
            (button) => button.dataset.value === sequence[index]
          );
          if (target && !target.classList.contains('kaching-bundles__swatch-buttons__button--selected')) target.click();
        });
        if (sequence.length >= 3) applyKachingGift(bar);

        window.setTimeout(() => {
          const ready = verifyKachingSelection(barId, sequence);
          setSubmitReady(ready);
          if (ready) variantSyncAttempts = 0;
          else {
            variantSyncAttempts += 1;
            if (variantSyncAttempts < 24) scheduleKachingSync(180);
          }
        }, 90);
      };

      const syncKaching = () => {
        syncTimer = undefined;
        const quantity = total();
        if (native) {
          extraMode = true;
          setAtcOverride(quantity);
          setSubmitReady(true);
          return;
        }
        const sequence = selectedSequence();
        const settings = getSettings();
        const config = settings && (settings.dealBars || []).find((bar) => Number(bar.quantity) === quantity);
        const bar = config && infoContainer && infoContainer.querySelector(`[data-deal-bar-id="${config.id}"]`);
        const largestBar = settings && largestDealBar(settings);

        extraMode = Boolean(largestBar && quantity > Number(largestBar.quantity));
        setAtcOverride(extraMode ? quantity : 0);
        if (extraMode) {
          appSyncAttempts = 0;
          setSubmitReady(true);
          return;
        }

        if (!config || !bar) {
          appSyncAttempts += 1;
          setSubmitReady(false);
          if (appSyncAttempts < 60) scheduleKachingSync(250);
          return;
        }

        appSyncAttempts = 0;
        const radio = bar.querySelector('input[type="radio"]');
        if (radio && !radio.checked) radio.click();
        window.setTimeout(() => applyKachingVariants(config.id, sequence), 30);
      };

      function scheduleKachingSync(delay = 0) {
        if (syncTimer) window.clearTimeout(syncTimer);
        syncTimer = window.setTimeout(syncKaching, delay);
      }

      function largestDealBar(settings) {
        return (settings.dealBars || []).reduce(
          (largest, bar) => (!largest || Number(bar.quantity) > Number(largest.quantity) ? bar : largest),
          null
        );
      }

      // Preis am Kaufbutton (pv-atc-total) aus den Liquid-Werten: bei Kaching für 5+ (keine passende
      // Stufe mehr), beim eigenen Angebot für jede Menge.
      function setAtcOverride(quantity) {
        const totalCents = quantity ? Number(root.getAttribute(`data-pv-total-${quantity}`)) : 0;
        const baseCents = quantity ? Number(root.getAttribute(`data-pv-base-${quantity}`)) : 0;
        window.pvAtcOverride = totalCents ? { total: totalCents / 100, base: baseCents / 100 } : null;
        if (typeof window.pvAtcTotalRepaint === 'function') window.pvAtcTotalRepaint();
      }

      const selectedItems = () =>
        rows
          .map((row, index) => ({ row, quantity: counts[index] }))
          .filter((entry) => entry.quantity > 0)
          .map((entry) => ({ id: Number(entry.row.dataset.variantId), quantity: entry.quantity }));

      // Eigenes Angebot: Deos ohne Properties (Mengenrabatt rechnet Shopify über den ganzen Warenkorb),
      // ab 3 die 0-€-Seife (data-variant-id zeigt im eigenen Modus auf aleppo-duschseife-gratis).
      const nativeItems = () => {
        const items = selectedItems();
        const giftVariantId = Number(giftSelect?.selectedOptions[0]?.dataset.variantId);
        if (total() >= 3 && giftVariantId) items.push({ id: giftVariantId, quantity: 1 });
        return items;
      };

      // Kaching zählt pro Bundle-id: alle Zeilen bekommen dieselbe id, sonst gibt es keinen Mengenrabatt.
      // Aufbau der Properties wie beim Widget-Kauf (Cart-Test 2026-10-07).
      const kachingItems = () => {
        const settings = getSettings();
        const largestBar = settings && largestDealBar(settings);
        if (!largestBar) return null;

        const bundleId = Math.random().toString(36).slice(2, 6).toUpperCase();
        const shared = { deal: settings.nanoId, v: settings.versionId, id: bundleId };
        const items = selectedItems().map((item) => ({
          ...item,
          properties: {
            __kaching_bundles: JSON.stringify({
              deal: shared.deal,
              pp: Number(root.dataset.productId),
              main: true,
              v: shared.v,
              id: shared.id,
              bid: largestBar.id,
            }),
          },
        }));
        const gift = (largestBar.freeGifts || [])[0];
        const giftVariantId = Number(giftSelect?.selectedOptions[0]?.dataset.variantId);
        if (gift && giftVariantId) {
          items.push({
            id: giftVariantId,
            quantity: gift.quantity || 1,
            properties: {
              __kaching_bundles: JSON.stringify({ id: shared.id, deal: shared.deal, v: shared.v, gift: gift.id }),
            },
          });
        }
        return items;
      };

      const addExtraToCart = async () => {
        const items = native ? nativeItems() : kachingItems();
        const productForm = infoContainer && infoContainer.querySelector('product-form');
        const submit = infoContainer && infoContainer.querySelector('[id^="ProductSubmitButton-"]');
        if (!items || !submit) return;

        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const body = { items };
        if (cart) {
          body.sections = cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
          cart.setActiveElement(document.activeElement);
        }

        submit.setAttribute('aria-disabled', 'true');
        submit.classList.add('loading');
        try {
          // kaching-cart=true: Kachings Skript läuft auf der Seite weiter und würde den Request sonst
          // durch die Deos seiner (versteckten) Stufe ersetzen. Siehe assets/cart.js.
          const query = native ? '?kaching-cart=true' : '';
          const response = await fetch(`${window.routes.cart_add_url}.js${query}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
          }).then((result) => result.json());

          if (response.status) {
            productForm?.handleErrorMessage?.(response.description);
            return;
          }
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', cartData: response });
          if (cart) cart.renderContents(response);
          else window.location = window.routes.cart_url;
        } catch (error) {
          console.error(error);
        } finally {
          submit.removeAttribute('aria-disabled');
          submit.classList.remove('loading');
        }
      };

      // Vor product-form und Kaching abfangen (Capture auf document), nur wenn der Builder selbst legt.
      const productFormElement = infoContainer && infoContainer.querySelector('product-form form');
      document.addEventListener(
        'submit',
        (event) => {
          if (!extraMode || event.target !== productFormElement) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          addExtraToCart();
        },
        true
      );

      // Kompakte Ansicht: zeigt, was im Set liegt, ohne dass jemand den Builder öffnen muss.
      const renderPick = () => {
        if (!pickList) return;
        pickList.replaceChildren();
        const addItem = (src, label, badge, modifier) => {
          const item = document.createElement('li');
          item.className = modifier ? `pv-ob-pick__item ${modifier}` : 'pv-ob-pick__item';
          const thumb = document.createElement('span');
          thumb.className = 'pv-ob-pick__thumb';
          if (src) {
            const image = document.createElement('img');
            image.src = src;
            image.alt = '';
            image.loading = 'lazy';
            thumb.append(image);
          }
          if (badge) {
            const tag = document.createElement('span');
            tag.className = 'pv-ob-pick__qty';
            tag.textContent = badge;
            thumb.append(tag);
          }
          const name = document.createElement('span');
          name.className = 'pv-ob-pick__name';
          name.textContent = label;
          item.append(thumb, name);
          pickList.append(item);
        };
        rows.forEach((row, index) => {
          if (counts[index] === 0) return;
          const source = row.querySelector('.pv-offer-builder__variant-image img');
          addItem(source && (source.currentSrc || source.src), row.dataset.variantTitle, counts[index] > 1 ? `${counts[index]}×` : '');
        });
        if (total() >= 3 && giftSelect) {
          addItem(
            giftSelect.selectedOptions[0]?.dataset.image,
            pick.dataset.giftTemplate.replace('__GIFT__', giftSelect.value),
            pick.dataset.giftBadge,
            'pv-ob-pick__item--gift'
          );
        }
      };

      const render = () => {
        const quantity = total();
        const sequence = selectedSequence();
        root.dataset.quantity = String(quantity);
        countLabel.textContent = root.getAttribute(`data-count-${quantity}`);
        summary.textContent = root.getAttribute(`data-summary-${quantity}`);
        progress.setAttribute('aria-label', root.getAttribute(`data-progress-${quantity}`));
        if (dockProgress) {
          dockProgress.setAttribute('aria-valuenow', String(quantity));
          dockProgress.setAttribute('aria-label', root.getAttribute(`data-progress-${quantity}`));
        }
        if (dockProgressFill) {
          dockProgressFill.style.width = `${Math.min(quantity, 4) * 25}%`;
          dockProgressFill.style.background = quantity >= 4 ? 'var(--pv-gold)' : 'var(--pv-green)';
        }
        if (dockCount) dockCount.textContent = String(quantity);
        if (dockTitle) dockTitle.textContent = root.getAttribute(`data-sticky-title-${quantity}`);
        if (dockBenefit) dockBenefit.textContent = root.getAttribute(`data-sticky-benefit-${quantity}`);
        if (dockPrice) dockPrice.textContent = root.getAttribute(`data-sticky-price-${quantity}`);
        if (dockCta) {
          dockCta.textContent = `${root.dataset.stickyCta} · ${root.getAttribute(`data-sticky-price-${quantity}`)}`;
        }
        if (giftPicker) giftPicker.hidden = quantity < 3;
        root.querySelectorAll('[data-pv-tier]').forEach((tier) => {
          tier.hidden = Number(tier.dataset.pvTier) !== quantity;
        });
        if (nudge) {
          nudge.textContent = nudge.getAttribute(`data-nudge-${Math.min(quantity, 4)}`) || '';
          nudge.disabled = quantity >= 4;
        }
        if (sheetMeta) {
          const activeTier = root.querySelector(`[data-pv-tier="${quantity}"]`);
          sheetMeta.textContent = ['.pv-ob-set__save', '.pv-ob-set__monthly']
            .map((selector) => activeTier?.querySelector(selector)?.textContent.trim())
            .filter(Boolean)
            .join(' · ');
        }
        if (sheetCta) {
          sheetCta.textContent = `${root.dataset.stickyCta} · ${root.getAttribute(`data-sticky-price-${quantity}`)}`;
        }
        if (goalFill) goalFill.style.width = `${((Math.min(quantity, 4) - 1) / 3) * 100}%`;
        if (goalMessage && quantity > 4) {
          goalMessage.textContent = root.getAttribute(`data-sticky-benefit-${quantity}`) || '';
        } else if (goalMessage) {
          goalMessage.innerHTML = progress.getAttribute(`data-goal-${quantity}`) || '';
        }
        progress.classList.toggle('is-full', quantity >= 4);
        root.querySelectorAll('[data-pv-goal-at]').forEach((mark) => {
          mark.classList.toggle('is-reached', Number(mark.dataset.pvGoalAt) <= quantity);
        });

        rows.forEach((row, index) => {
          const output = row.querySelector('[data-pv-quantity]');
          const decrease = row.querySelector('[data-pv-decrease]');
          const increase = row.querySelector('[data-pv-increase]');
          output.textContent = String(counts[index]);
          row.classList.toggle('is-selected', counts[index] > 0);
          decrease.disabled = counts[index] === 0 || quantity === 1 || row.dataset.available !== 'true';
          increase.disabled = quantity >= maxQty || row.dataset.available !== 'true';
        });

        stepButtons.forEach((button) => {
          const step = Number(button.dataset.pvStep);
          const active = step === Math.min(quantity, 4);
          button.classList.toggle('is-active', active);
          button.classList.toggle('is-reached', step <= quantity);
          button.setAttribute('aria-pressed', String(active));
        });

        // Ab 4 steht der letzte Stufen-Knopf für die gewählte Menge („6 Deos · 89,98 €").
        if (maxPill) {
          const shown = Math.max(4, quantity);
          const label = maxPill.querySelector('.pv-ob-tier__count');
          const price = maxPill.querySelector('.pv-ob-tier__price');
          if (label) label.textContent = maxPill.getAttribute(`data-label-${shown}`) || label.textContent;
          if (price) price.textContent = maxPill.getAttribute(`data-price-${shown}`) || price.textContent;
        }

        renderPick();
        variantSyncAttempts = 0;
        setSubmitReady(false);
        scheduleKachingSync();
      };

      const setTotal = (target, preferDistinct = false) => {
        const boundedTarget = Math.max(1, Math.min(maxQty, target));
        if (preferDistinct) counts.fill(0);

        while (total() > boundedTarget) {
          for (let index = counts.length - 1; index >= 0; index -= 1) {
            if (counts[index] > 0) {
              counts[index] -= 1;
              break;
            }
          }
        }

        while (total() < boundedTarget) {
          const emptyIndex = availableRows
            .map((row) => rows.indexOf(row))
            .find((index) => counts[index] === 0);
          const targetIndex = emptyIndex === undefined ? rows.indexOf(availableRows[0]) : emptyIndex;
          if (targetIndex < 0) break;
          counts[targetIndex] += 1;
        }
        render();
      };

      rows.forEach((row, index) => {
        row.querySelector('[data-pv-decrease]').addEventListener('click', () => {
          if (counts[index] === 0 || total() === 1) return;
          counts[index] -= 1;
          render();
        });
        row.querySelector('[data-pv-increase]').addEventListener('click', () => {
          if (total() >= maxQty || row.dataset.available !== 'true') return;
          counts[index] += 1;
          render();
        });
      });

      stepButtons.forEach((button) => {
        button.addEventListener('click', () => setTotal(Number(button.dataset.pvStep)));
      });

      const giftImage = root.querySelector('.pv-offer-builder__gift-img');
      const showGiftImage = () => {
        const src = giftSelect?.selectedOptions[0]?.dataset.image;
        if (!giftImage || !src) return;
        giftImage.removeAttribute('srcset');
        giftImage.src = src;
      };

      const scents = (() => {
        const source = infoContainer?.querySelector('script[data-pv-scents]') || document.querySelector('script[data-pv-scents]');
        try {
          return source ? JSON.parse(source.textContent) : [];
        } catch (error) {
          return [];
        }
      })();

      rows.forEach((row) => {
        const scent = scents.find((entry) => entry.name === row.dataset.variantTitle);
        const panel = row.querySelector('[data-pv-scent-panel]');
        const toggles = Array.from(row.querySelectorAll('[data-pv-scent-toggle]'));
        if (!scent || !panel) return;

        const notes = document.createElement('p');
        notes.className = 'pv-offer-builder__scent-notes';
        scent.notes.split(',').map((note) => note.trim()).filter(Boolean).forEach((note) => {
          const item = document.createElement('span');
          item.textContent = note;
          notes.append(item);
        });
        if (notes.childElementCount) panel.append(notes);
        if (scent.text) {
          const text = document.createElement('p');
          text.className = 'pv-offer-builder__scent-text';
          text.textContent = scent.text;
          panel.append(text);
        }
        panel.style.setProperty('--pv-scent', scent.color);

        toggles.forEach((toggle) => {
          toggle.hidden = false;
          toggle.addEventListener('click', () => {
            const open = panel.hidden;
            panel.hidden = !open;
            toggles.forEach((item) => item.setAttribute('aria-expanded', String(open)));
          });
        });
      });

      nudge?.addEventListener('click', () => {
        if (total() < 4) setTotal(total() + 1);
      });

      const closeSheet = () => {
        if (!sheet || sheet.hidden) return;
        sheet.hidden = true;
        document.documentElement.classList.remove('pv-ob-sheet-open');
        configure?.setAttribute('aria-expanded', 'false');
        configure?.focus({ preventScroll: true });
        updateDock();
      };

      const openSheet = () => {
        sheet.hidden = false;
        document.documentElement.classList.add('pv-ob-sheet-open');
        configure?.setAttribute('aria-expanded', 'true');
        sheetPanel?.focus({ preventScroll: true });
      };

      if (sheet) {
        sheet.querySelectorAll('[data-pv-sheet-close]').forEach((button) => button.addEventListener('click', closeSheet));
        sheet.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') closeSheet();
        });
        sheetCta?.addEventListener('click', () => {
          const submit = infoContainer && infoContainer.querySelector('[id^="ProductSubmitButton-"]');
          if (!submit || submit.disabled) return;
          closeSheet();
          submit.click();
        });
      }

      configure?.addEventListener('click', () => {
        if (sheet) {
          openSheet();
          return;
        }
        const open = config.hidden;
        config.hidden = !open;
        if (pickSummary) pickSummary.hidden = open;
        configure.setAttribute('aria-expanded', String(open));
        configureLabel.textContent = open ? pick.dataset.labelClose : pick.dataset.labelOpen;
        updateDock();
      });

      giftSelect?.addEventListener('change', () => {
        showGiftImage();
        renderPick();
        variantSyncAttempts = 0;
        setSubmitReady(false);
        scheduleKachingSync();
      });

      dockCta?.addEventListener('click', () => {
        const submit = infoContainer && infoContainer.querySelector('[id^="ProductSubmitButton-"]');
        if (submit && !submit.disabled) submit.click();
      });

      // Die Leiste ergänzt den Warenkorb-Button, sie ersetzt ihn nicht: Solange er an seinem Platz
      // unter dem Builder zu sehen ist, bleibt sie weg, damit nie zwei Kaufknöpfe gleichzeitig stehen.
      const buyButtons = infoContainer && infoContainer.querySelector('.product-form__buttons');
      const updateDock = () => {
        const reached = root.getBoundingClientRect().top < window.innerHeight * 0.85;
        const buttonRect = buyButtons && buyButtons.getBoundingClientRect();
        const buttonVisible = Boolean(
          buttonRect && buttonRect.height > 0 && buttonRect.bottom > 0 && buttonRect.top < window.innerHeight
        );
        document.documentElement.classList.toggle('pv-ob-reached', reached);
        document.documentElement.classList.toggle('pv-ob-docked', reached && !buttonVisible);
      };
      window.addEventListener('scroll', updateDock, { passive: true });
      window.addEventListener('resize', updateDock, { passive: true });
      updateDock();

      setTotal(3, true);
    };

    const start = () => document.querySelectorAll('.pv-offer-builder').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  })();
  } catch(e) { console.error(e); }
})();

})();
